// XXX: This widget needs to be generalized
import $ from "jquery";
import Base from "@patternslib/patternslib/src/core/base";
import _ from "underscore";


export default Base.extend({
    name: 'multiselection',
    trigger: '.pat-multiselection',
    parser: 'mockup',

    defaults: {
      classFieldName: "mb-2",
      classRowName: "border border-primary border-3 m-2 p-2",
      classRelatedItemName: "multiselection-row-relateditem-field",
      classTitleItemName: "multiselection-row-title-field",
      classDescriptionItemName: "multiselection-row-description-field",
      classUrlItemName: "multiselection-row-url-field",
      patternRelateditemsOptions: {}
    },

    renderRows: async function(values){
      var self = this;
      _.each(values, async function (value) {
        await self.renderRow(value);
      });
    },

    removeRow: function(){
      var self = this;
      if (self.number_of_items > 0){
        self.number_of_items--;
        $(".multiselection-row", self.$wrapper).eq(self.number_of_items).remove();
        self.updateval();
      }
    },

    renderRow: async function(value){
      var self = this,
          uid = "",
          title = "",
          description = "",
          url = "",
          $wrapper = $("<div class='multiselection-row'></div>")
                    .addClass(self.options.classRowName)
                    .appendTo(self.$wrapper);

      self.number_of_items++;

      if (value){
        uid = value['uid'];
        title = value['title'];
        description = value['description'];
        url = value['url'];
      }

      $('<div></div>')
      .addClass(self.options.classFieldName)
      .appendTo($wrapper)
      .append(
        $('<input type="text" class="multiselect-input form-control" name="uid"/>')
          .addClass(self.options.classRelatedItemName)
          .val(uid)
          .patternRelateditems(self.options.patternRelateditemsOptions)
          .on("change", function() {
            self.updateval();
          })
      );

      $('<div></div>')
      .addClass(self.options.classFieldName)
      .appendTo($wrapper)
      .append(
        $('<span>Title:</span>')
      )
      .append(
        $('<input type="text" class="multiselect-input form-control" name="title"/>')
          .addClass(self.options.classTitleItemName)
          .val(title)
          .on("change", function() {
            self.updateval();
          })
      );

      $('<div></div>')
      .addClass(self.options.classFieldName)
      .appendTo($wrapper)
      .append(
        $('<span>Description:</span>')
      )
      .append(
        $('<input type="text" class="multiselect-input form-control" name="description"/>')
        .addClass(self.options.classDescriptionItemName)
        .val(description)
        .on("change", function() {
          self.updateval();
        })
      );

      $('<div></div>')
      .addClass(self.options.classFieldName)
      .appendTo($wrapper)
      .append(
        $('<span>URL:</span>')
      )
      .append(
        $('<input type="text" class="multiselect-input form-control" name="url"/>')
        .addClass(self.options.classUrlItemName)
        .val(url)
        .on("change", function() {
          self.updateval();
        })
      );

    let Sortable = await import("sortablejs");
    Sortable = Sortable.default;
    new Sortable(self.$wrapper[0], {
      animation: 150,
      ghostClass: 'blue-background-class',
      onEnd: function (e) {
          this.updateval();
      }.bind(this)
    });
    },

    updateval: function() {
      var self = this;
      var values = [];
      _.each($(".multiselection-row", self.$wrapper), function (value) {
        values.push({
          'uid': $("input.multiselect-input[name='uid']", value).val(),
          'title': $("input.multiselect-input[name='title']", value).val(),
          'description': $("input.multiselect-input[name='description']", value).val(),
          'url': $("input.multiselect-input[name='url']", value).val(),
        });
      });
      self.$el.val(JSON.stringify(values));
    },

    init: async function() {
      var self = this;

      self.number_of_items = 0;

      // hide input element
      self.$el.hide();

      // create wrapper for out criteria
      self.$wrapper = $("<div/>");
      self.$el.after(
        $("<button class='btn btn-danger ms-2'>Remove last</button>")
        .on("click", function(event){
          event.preventDefault();
          self.removeRow();
        })
      );

      self.$el.after(
        $("<button class='btn btn-success ms-2'>Add new</button>")
        .on("click", function(event){
          event.preventDefault();
          self.renderRow();
        })
      );

      self.$el.after(self.$wrapper);

      // initialization can be detailed if by ajax
      self.initialized = false;
      self.renderRows(JSON.parse(self.$el.val()));
      self.$el.trigger("initialized");
      self.initialized = true;

    }
});
